import { FormsConstants } from './forms-constants';
import { FunctionalElement, FUNCTIONAL_ELEMENT_TYPE } from './functional-element';

export type StandardFunctionalElement = Readonly<{
    label: string;
    type: FUNCTIONAL_ELEMENT_TYPE.STANDARD | FUNCTIONAL_ELEMENT_TYPE.REMARK;
}> &
    FunctionalElement;

export const initialStandardFunctionalElementState: StandardFunctionalElement = {
    id: -1,
    xmlId: '',
    label: '',
    type: FUNCTIONAL_ELEMENT_TYPE.STANDARD,
    contentLoadedFromXml: false,
    controllingCheckpoint: '',
    controllingOption: undefined,
    disabled: false,
    parentId: -1,
    choices: {},
    remarks: '',
    remarksLabel: '',
    remarksXmlId: '',
    elementType: FormsConstants.ELEMENT_TYPE.UNKNOWN,
    optionSet: undefined,
};

export function isStandardFunctionalElement(f: FunctionalElement): f is StandardFunctionalElement {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.STANDARD;
}

export function isRemarksFunctionalElement(f: FunctionalElement): f is StandardFunctionalElement {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.REMARK;
}
